import { useEffect, useState } from 'react';
import global from 'global';
import type { ContentRect } from '../../common/types/content-rect';
const useResizeObserver = (ref: HTMLElement | null): ContentRect | null => {
  // on newer browsers this will return blockSize && inlineSize
  // on older browsers this will return height && width
  const [contentRect, setContentRect] = useState<ContentRect | null>(null);
  useEffect(() => {
    if (!ref) return;
    const observeTarget = ref;
    let resizeObserver;
    resizeObserver = new global.ResizeObserver(entries => {
      // reading only 0th index because only one element is observed at once with this hook
      // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
      // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentRect
      // contentRect may be deprecated in the future
      const contentBoxSizeProperties = entries[0].contentBoxSize?.[0];
      const properties = contentBoxSizeProperties ? {
        height: contentBoxSizeProperties.blockSize,
        width: contentBoxSizeProperties.inlineSize
      } : {
        height: entries[0].contentRect.height,
        width: entries[0].contentRect.width
      };
      setContentRect(properties);
    });
    if (observeTarget) {
      resizeObserver.observe(observeTarget);
    }
    return () => {
      resizeObserver?.disconnect();
    };
  }, [ref]);
  return contentRect;
};
export default useResizeObserver;